import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  jobPostingsKey,
  SubmitJobPosting,
  updateJobsPostingsRoute,
} from '@features/jobPostings';
import { errorMessage } from '@features/positions';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';
import { applicationsCountsKey } from '@features/applications';

type UseUpdateJobPostingProps = {
  refetch?: boolean;
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateJobPosting = ({
  refetch,
  setErrorText = () => {},
}: UseUpdateJobPostingProps) => {
  const client = useQueryClient();

  const { mutate: updateJobPosting, isLoading: isUpdatingJobPosting } =
    useMutation({
      mutationFn: (variables: SubmitJobPosting) =>
        axiosInstance
          .post(updateJobsPostingsRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status === 200) {
          setErrorText('');
          if (refetch) {
            client.invalidateQueries([jobPostingsKey]);
            client.invalidateQueries([applicationsCountsKey]);
          }
        } else if (data.status === 400) {
          client.invalidateQueries([profileKey]);
        } else {
          setErrorText(data?.message ?? errorMessage);
        }
      },
      onError: () => setErrorText(errorMessage),
    });

  return { updateJobPosting, isUpdatingJobPosting };
};
